import * as ko from "knockout";
import * as Data from "../interfaces/data";
import * as User from "../interfaces/user";
import * as EventUtil from "./eventUtil";
import * as Global from "./global";
import * as Util from "./util";

interface INavigationBarViewModel {
    topMenu: KnockoutObservableArray<User.ITopMenu>;
    customers: KnockoutObservableArray<User.IUserSessionCustomer>;
    currentCustomerShortName: KnockoutObservable<string>;
    userName: KnockoutObservable<string>;
    userItems: KnockoutObservableArray<User.IMenuItem>;
    showUserItems: KnockoutObservable<boolean>;
    onMenuItemClick: (menuItem: User.IMenuItem) => void;
    onCustomerClick: (customer: User.IUserSessionCustomer) => void;
    onContactUsClick: () => void;

}

export class NavigationBar {
    // ------------------------------------------------------
    // private Properties
    // ------------------------------------------------------
    private viewModel: INavigationBarViewModel;

    // ------------------------------------------------------
    // constructor
    // ------------------------------------------------------
    constructor() {
        const me: NavigationBar = this;

        this.viewModel = {
            topMenu: ko.observableArray(),

            // change customer drop down
            customers: ko.observableArray(),
            currentCustomerShortName: ko.observable(""),

            // user name drop down
            // note that available user items are the same for all users
            userName: ko.observable(""),
            userItems: ko.observableArray([]),
            showUserItems: ko.observable(false),

            onMenuItemClick(menuItem: User.IMenuItem): void {
                Global.app().router().navigate(menuItem.URL, true);
            },
            onContactUsClick(): void {
               Global.app().router().navigate("/ContactUs", true);
            },
            onCustomerClick(customer: User.IUserSessionCustomer): void {
                me.viewModel.currentCustomerShortName(customer.ShortName);
            },
        };

        ko.applyBindings(this.viewModel, $("nav[data-id='master_Navigation']")[0]);

        // subscribe to TargetTemplate change event.  If the user modifies a target template
        // then we want to reload the menu, because the Targets menu may have changed
        Global.app().events().on(EventUtil.EVENT_TARGETTEMPLATECHANGE, () => {
            me.reloadMenu();
        });

    }

    // ------------------------------------------------------
    // public Methods
    // ------------------------------------------------------
    public load(userSession: User.IUserSession): void {
        if (userSession == null) {
            // user is not logged in
            this.viewModel.showUserItems(false);
        } else {
            this.viewModel.showUserItems(!Global.app().hideMenu);
            this.updateApplicationNavigationViewModel(userSession.ApplicationNavigation);
            this.viewModel.userName(userSession.FirstName);

            this.viewModel.customers.removeAll();
            userSession.Customers.forEach((customer: User.IUserSessionCustomer) => {
                this.viewModel.customers.push(customer);
            });

            if (userSession.Customers.length > 0) {
                this.viewModel.currentCustomerShortName(userSession.Customers[0].ShortName);
            }

            this.viewModel.userItems(this.getUserMenuItems(userSession));

            // the nav tag has the hidden class, so it doesn't appear when the page
            // first loads.  Remove it now to the nav bar will appear
            $("nav[data-id='master_Navigation']").removeClass("hidden");
        }
    }

    // ------------------------------------------------------
    // private Methods
    // ------------------------------------------------------
    private updateApplicationNavigationViewModel(applicationNavigation: User.INavigation): void {
        this.viewModel.topMenu.removeAll();
        applicationNavigation.TopMenu.forEach((topMenu: User.ITopMenu) => {
            this.viewModel.topMenu.push(topMenu);
        });
    }

    private getUserMenuItems(userSession: User.IUserSession): User.IMenuItem[] {
        const menuItems: User.IMenuItem[] = [];

        if (!userSession.UsesExternalAuthentication) {
            menuItems.push({ ItemName: "Change Password", URL: "/ChangePassword" });
        }
        menuItems.push({ ItemName: "Edit Your Profile", URL: "/UserProfile" });
        menuItems.push({ ItemName: "Logout", URL: "/Logout" });

        return menuItems;
    }

    // reload the menu from the web service.  Used when the user changes something
    // that might change the menu options (like modify a TargetTemplate)
    private reloadMenu(): void {
        const me: NavigationBar = this;

        Util.callWebService(
            "/api/App/LoggedInMenu",
            "GET")
            .done((response: Data.IResponse<User.INavigation>) => {
                if (response.Success) {
                    me.updateApplicationNavigationViewModel(response.Payload);
                }
            });

    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--7!./src/script/common/navigation.ts